var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7065_92742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2344 8.5625H10.5156V14.4219H22.2344V8.5625Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1406 27.1172V5.63281C26.1406 5.09347 25.7034 4.65625 25.1641 4.65625L7.58594 4.65625C7.0466 4.65625 6.60938 5.09347 6.60938 5.63281V27.1172C6.60938 27.6565 7.0466 28.0938 7.58594 28.0938H25.1641C25.7034 28.0938 26.1406 27.6565 26.1406 27.1172Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4922 20.2812C12.3012 20.2812 12.957 19.6254 12.957 18.8164C12.957 18.0074 12.3012 17.3516 11.4922 17.3516C10.6832 17.3516 10.0273 18.0074 10.0273 18.8164C10.0273 19.6254 10.6832 20.2812 11.4922 20.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 20.2812C17.184 20.2812 17.8398 19.6254 17.8398 18.8164C17.8398 18.0074 17.184 17.3516 16.375 17.3516C15.566 17.3516 14.9102 18.0074 14.9102 18.8164C14.9102 19.6254 15.566 20.2812 16.375 20.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2578 20.2812C22.0668 20.2812 22.7227 19.6254 22.7227 18.8164C22.7227 18.0074 22.0668 17.3516 21.2578 17.3516C20.4488 17.3516 19.793 18.0074 19.793 18.8164C19.793 19.6254 20.4488 20.2812 21.2578 20.2812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4922 25.1641C12.3012 25.1641 12.957 24.5082 12.957 23.6992C12.957 22.8902 12.3012 22.2344 11.4922 22.2344C10.6832 22.2344 10.0273 22.8902 10.0273 23.6992C10.0273 24.5082 10.6832 25.1641 11.4922 25.1641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.375 25.1641C17.184 25.1641 17.8398 24.5082 17.8398 23.6992C17.8398 22.8902 17.184 22.2344 16.375 22.2344C15.566 22.2344 14.9102 22.8902 14.9102 23.6992C14.9102 24.5082 15.566 25.1641 16.375 25.1641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2578 25.1641C22.0668 25.1641 22.7227 24.5082 22.7227 23.6992C22.7227 22.8902 22.0668 22.2344 21.2578 22.2344C20.4488 22.2344 19.793 22.8902 19.793 23.6992C19.793 24.5082 20.4488 25.1641 21.2578 25.1641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7065_92742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.25,
    height: 31.25,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.90966d32.svg";
export { ForwardRef as ReactComponent };